import { APP_VERSION } from '@/version';

/**
 * Tiny always-on-top version badge in the bottom-right corner.
 * Kept intentionally small + low-contrast so it never fights with UI content
 * but is always available for support/debugging.
 */
export default function VersionBadge() {
  return (
    <div
      className="fixed bottom-2 right-2 z-[9999] pointer-events-none select-none text-[10px] font-mono text-white/40 bg-black/40 px-1.5 py-0.5 rounded"
      data-testid="app-version-badge"
      aria-hidden="true"
    >
      {APP_VERSION}
    </div>
  );
}
